import { TextCodes } from '@api/types/translation/TextCodes';
import { DropdownField, DropdownOption, useTechnicalMessageContext } from '@components';
import { t } from '@translations';
import { useMemo } from 'react';

type SortingDropdownProps = 'desc' | 'asc';

export const TechnicalMessageSorting = () => {
  const { updateSorting, getFilterValue } = useTechnicalMessageContext();
  const sortOptions = useMemo<DropdownOption<SortingDropdownProps>[]>(
    () => [
      { label: t(TextCodes.Sorting.DateAsc), value: 'asc' },
      { label: t(TextCodes.Sorting.DateDesc), value: 'desc' },
    ],
    []
  );

  return (
    <DropdownField
      label={t(TextCodes.Sorting.Sorting)}
      value={getFilterValue('Sorting')}
      options={sortOptions || []}
      getValue={(value) => updateSorting(value as SortingDropdownProps)}
    />
  );
};
